import { ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';

import { Video } from 'atoms/ui/Video';
import { CARD_BORDER_RADIUS } from 'lib/cards';

import movVideo from './assets/energized_limited.mov';

const fadeInOut = keyframes`
  0% {
    opacity: 0;
  }
  45% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const Wrapper = styled.div`
  position: relative;
  isolation: isolate;
`;

const EnergizedVideo = styled(Video)`
  inset: 0;
  overflow: hidden;
  position: absolute;
  border-radius: ${CARD_BORDER_RADIUS};

  z-index: 1;
  width: auto;
  height: auto;
  pointer-events: none;
  mix-blend-mode: screen;

  > * {
    overflow: visible;
  }
`;

const GlowFilter = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0;
  z-index: -1;
  pointer-events: none;
  filter: blur(40px) saturate(2);

  & > * {
    max-width: 100%;
  }

  animation: 1700ms ${fadeInOut} infinite ease-in-out;
`;

export const Energized = ({ children }: { children: ReactNode }) => {
  if (!children) return null;

  return (
    <Wrapper>
      <GlowFilter>{children}</GlowFilter>
      {children}
      <EnergizedVideo
        loop
        autoPlay
        muted
        playsInline
        hideMutedIcon
        sources={[{ src: movVideo, type: 'video/mp4' }]}
      />
    </Wrapper>
  );
};
